export default ['wirisEditor', 'wirisChemistry', 'bold', 'italic', 'underline', 'strikeThrough',
    'subscript', 'superscript', 'textColor', 'backgroundColor',
    'fontFamily', 'fontSize', 'lineHeight',
    'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'insertLink',
    'insertImage', 'embedly', 'insertFile', 'insertTable', 'emoticons', 'fontAwesome',
    'specialCharacters', 'print', 'spellChecker', 'clearFormatting',
    'help', 'html', 'undo', 'redo', 'fullscreen', 'clear', 'insertHiddenText', 'insertFaq'];
